const otsb_collectionPagination = (config = {}) => ({
  rootEL: '',
  nextUrl: config.nextUrl || null,
  type: config.type || 'infinite',
  paginateCurrentOffset: config.paginateCurrentOffset || 0,
  paginateItems: config.paginateItems || 0,
  paginatePageSize: config.paginatePageSize || 0,
  loading: false,

  initCollectionPagination(el, nextUrl, prevUrl, paginateCurrentOffset, paginateItems, paginatePageSize) {
    this.rootEL = el;
    if (this.type === '') {
      this.type = el?.dataset.paginationType;
    }
    if (!this.nextUrl) {
      this.nextUrl = nextUrl;
    }
    if (!this.paginateCurrentOffset) {
      this.paginateCurrentOffset = paginateCurrentOffset || 0;
      if (this.paginateCurrentOffset === 0) {
        if (paginatePageSize < paginateItems) {
          this.paginateCurrentOffset = paginatePageSize;
        } else {
          this.paginateCurrentOffset = paginateItems;
        }
      }
    }
    if (!this.paginateItems) {
      this.paginateItems = paginateItems || 0;
    }
    if (!this.paginatePageSize) {
      this.paginatePageSize = paginatePageSize || 0;
    }

    this.loadInfinite();
  },

  get progress() {
    if (!this.paginateItems) return 0;
    return (this.paginateCurrentOffset / this.paginateItems) * 100;
  },

  loadInfinite() {
    if (this.type !== 'infinite') return;

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.loading && this.nextUrl) {
        this.loadMore();
      }
    });

    this.$nextTick(() => {
      requestAnimationFrame(() => {
        if (this.$refs.trigger) {
          this.observer.observe(this.$refs.trigger);
        }
      })
    });
  },

  async loadMore() {
    if (!this.nextUrl || this.loading) return;

    this.loading = true;

    try {
      const res = await fetch(this.nextUrl);
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelector('[data-render-grid]');
      const currentGrid = document.querySelector('[data-render-grid]');

      if (newItems && currentGrid) {
        const items = [...newItems.children];
        items.forEach(el => {
          currentGrid.appendChild(el);
        });

        this.paginateCurrentOffset = Math.min(this.paginateCurrentOffset + this.paginatePageSize, this.paginateItems);
      }

      // update next url
      const nextBtn = doc.querySelector('[data-pagination-next]');
      const nextTrigger = doc.querySelector('[data-infinite-trigger]');

      if (nextBtn) {
        this.nextUrl = nextBtn.dataset.url;
      } else if (nextTrigger) {
        this.nextUrl = nextTrigger.dataset.url;
      } else {
        this.nextUrl = null;
      }

    } catch (err) {
      console.error('Pagination error:', err);
    }

    this.loading = false;
    if (!this.nextUrl) {
      this.rootEL.querySelector('.otsb-button-load-more')?.classList.add('ot-hidden-important');
      this.rootEL.querySelector('.progress-bar')?.classList.add('ot-hidden-important');
    }
  }
});

window.otsb_collectionPagination = otsb_collectionPagination;

document.addEventListener('alpine:init', () => {
  Alpine.store('otsb_collectionPagination', otsb_collectionPagination());
  Alpine.data('otsb_collectionPagination', otsb_collectionPagination);
});
